import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { add, isFuture, isPast } from 'date-fns';

import { useAuctionCurrentPrice } from '#src/lib/auctions.ts';

import type { useGetAuctionDetails_auction } from './__generated__/useGetAuctionDetails.graphql.ts';

export const useGetAuctionDetails = (
  auction: useGetAuctionDetails_auction | null
) => {
  const endDate = auction?.endDate;
  const price = useAuctionCurrentPrice(auction);
  if (!auction) return undefined;

  const auctionIsOnSale = isFuture(add(auction.endDate, { seconds: 15 }));

  if (auctionIsOnSale && price && endDate) {
    const ended = isPast(endDate);
    return {
      endDate,
      ended,
      price,
      currency: auction?.currency,
    };
  }
  return undefined;
};

useGetAuctionDetails.fragments = {
  auction: gql`
    fragment useGetAuctionDetails_auction on TokenAuction {
      id
      endDate
      currency
      ...useAuctionCurrentPrice_auction
    }
    ${useAuctionCurrentPrice.fragments.auction}
  ` as TypedDocumentNode<useGetAuctionDetails_auction>,
};
